import { SelectOption } from 'global';
import { TextFieldProps } from '@mui/material';
import { AutocompleteProps } from '@mui/material/Autocomplete';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';

import { convertFactToSelectOptions } from '../lib';

export const factNamesNumeric = convertFactToSelectOptions(FACT_NAMES_NUMERIC);
export const factNamesBoolean = convertFactToSelectOptions(FACT_NAMES_BOOLEAN);
export const factNamesString = convertFactToSelectOptions(FACT_NAMES_STRING);

export const allFacts = [...factNamesNumeric, ...factNamesString, ...factNamesBoolean];

// String field option sets
const equipmentTypeOptions = ['Truck', 'Trailer', 'Backhoe', 'Excavator', 'Dozer', 'Loader', 'Grader', 'Scraper'].map(
  v => ({ value: v, label: v })
) as SelectOption[];

const equipmentClassOptions = ['Class 3', 'Class 4', 'Class 5', 'Class 6', 'Class 7', 'Class 8'].map(v => ({
  value: v,
  label: v,
})) as SelectOption[];

const financingTypeOptions = ['Lease', 'Loan', 'Retail Installment Contract'].map(v => ({
  value: v,
  label: v,
})) as SelectOption[];

const legalStructureOptions = ['LLC', 'Corporation', 'Partnership', 'Sole Proprietorship'].map(v => ({
  value: v,
  label: v,
})) as SelectOption[];

const equipmentConditionOptions = ['New', 'Used'].map(v => ({ value: v, label: v })) as SelectOption[];

const billingFrequencyOptions = ['Monthly', 'Quarterly', 'Annual', 'Full Term'].map(v => ({
  value: v,
  label: v,
})) as SelectOption[];

// Scorecard-specific options
const comparableLoanHistoryOptions = ['default', 'none', 'clean'].map(v => ({ value: v, label: v })) as SelectOption[];

const driverStructureOptions = ['leased', 'w2', 'owner'].map(v => ({ value: v, label: v })) as SelectOption[];

const homeOwnershipOptions = ['rents', 'owns'].map(v => ({ value: v, label: v })) as SelectOption[];

export const autocompletePropsByType: Partial<
  Record<
    FACT_NAMES_STRING,
    Omit<AutocompleteProps<SelectOption, true, false, false>, 'renderInput'> & {
      textFieldProps?: Partial<TextFieldProps>;
    }
  >
> = {
  [FACT_NAMES_STRING.EQUIPMENT_TYPE]: {
    textFieldProps: {
      required: true,
      label: 'Equipment Type',
    },
    options: equipmentTypeOptions,
  },
  [FACT_NAMES_STRING.EQUIPMENT_CLASS]: {
    textFieldProps: {
      required: true,
      label: 'Equipment Class',
    },
    options: equipmentClassOptions,
  },
  [FACT_NAMES_STRING.FINANCING_TYPE]: {
    textFieldProps: {
      required: true,
      label: 'Financing Type',
    },
    options: financingTypeOptions,
  },
  [FACT_NAMES_STRING.LEGAL_STRUCTURE]: {
    textFieldProps: {
      required: true,
      label: 'Legal Structure',
    },
    options: legalStructureOptions,
  },
  [FACT_NAMES_STRING.EQUIPMENT_CONDITION]: {
    textFieldProps: {
      required: true,
      label: 'Equipment Condition',
    },
    options: equipmentConditionOptions,
  },
  [FACT_NAMES_STRING.BILLING_FREQUENCY]: {
    textFieldProps: {
      required: true,
      label: 'Billing Frequency',
    },
    options: billingFrequencyOptions,
  },
  [FACT_NAMES_STRING.COMPARABLE_LOAN_HISTORY]: {
    textFieldProps: {
      required: true,
      label: 'Select the Comparable Loan History',
    },
    options: comparableLoanHistoryOptions,
  },
  [FACT_NAMES_STRING.DRIVER_STRUCTURE]: {
    textFieldProps: {
      required: true,
      label: 'Select a Driver Structure',
    },
    options: driverStructureOptions,
  },
  [FACT_NAMES_STRING.HOME_OWNERSHIP]: {
    textFieldProps: {
      required: true,
      label: 'Select a Home Ownership',
    },
    options: homeOwnershipOptions,
  },
};

export const booleanOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
